/**
 * Picture-in-Picture für native Video-Elemente abschalten (Produktentscheidung).
 * Siehe HTMLVideoElement.disablePictureInPicture / Attribut disablepictureinpicture.
 */
export function ensureVideoPictureInPictureDisabled(
  video: HTMLVideoElement
): void {
  try {
    video.setAttribute("disablepictureinpicture", "");
    video.disablePictureInPicture = true;
  } catch {
    // Sehr alte Engines / eingeschränkte WebViews: best effort
  }
}

/** Alle Video-Elemente unter root (inkl. root selbst) patchen. */
export function patchVideoElementsInSubtree(root: ParentNode): void {
  if (typeof root.querySelectorAll !== "function") return;
  for (const node of root.querySelectorAll("video")) {
    if (node instanceof HTMLVideoElement) {
      ensureVideoPictureInPictureDisabled(node);
    }
  }
}
